if (!customElements.get('upsell-button')) {
  class UpsellButton extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    handleClick(event) {
      event.preventDefault();
      if (this.hasAttribute('data-loading')) return;

      this.toggleAttribute('data-loading', true);
      this.addToCart();
    }

    addToCart() {
      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) {
        this.removeAttribute('data-loading');
        return;
      }

      // Der Drawer wird über die Section-Rendering-API neu geholt – dieselben
      // Sections, die auch die Mengen-Buttons im Drawer aktualisieren.
      const body = JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });

      fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status || response.errors) {
            this.showError(response.description || response.message);
            return;
          }

          this.renderCartDrawer(response.sections);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'upsell-products',
              productVariantId: variantId,
              cartData: response,
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.showError();
        })
        .finally(() => this.removeAttribute('data-loading'));
    }

    renderCartDrawer(sections) {
      const drawer = document.querySelector('cart-drawer');
      const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
      const drawerHTML = sections?.['cart-drawer'];

      // Ohne Section-HTML wäre der Drawer nach dem Hinzufügen veraltet – dann
      // lieber die Seite neu laden als eine falsche Summe stehen lassen.
      if (!drawerInner || !drawerHTML) {
        window.location.reload();
        return;
      }

      drawerInner.innerHTML = this.getSectionInnerHTML(drawerHTML, '.drawer__inner');
      drawer?.classList.remove('is-empty');
      drawerInner.classList.remove('is-empty');

      const bubble = document.getElementById('cart-icon-bubble');
      const bubbleHTML = sections['cart-icon-bubble'];
      if (bubble && bubbleHTML) {
        bubble.innerHTML = this.getSectionInnerHTML(bubbleHTML, '.shopify-section');
      }

      if (drawer && !drawer.classList.contains('active')) drawer.open?.();
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? '';
    }

    showError(message) {
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = message || window.cartStrings?.error || '';
      console.error(message || 'Adding the upsell product to the cart failed.');
    }
  }

  customElements.define('upsell-button', UpsellButton);
}
